import { Link } from 'react-router-dom';
import { siteConfig } from '@/mocks/siteConfig';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[600px] md:h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20luxurious%20gaming%20room%20with%20neon%20golden%20and%20red%20lights%2C%20abstract%20geometric%20patterns%2C%20elegant%20casino%20atmosphere%2C%20floating%20golden%20particles%2C%20dramatic%20lighting%2C%20rich%20dark%20background%20with%20warm%20accents%2C%20cinematic%20composition&width=1920&height=900&seq=hero-bg-main-01&orientation=landscape"
          alt="九游娱乐 - 官方游戏平台"
          title="九游娱乐官方平台海量游戏娱乐体验"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/50 to-foreground-950/80"></div>

      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-4 md:px-6 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 border border-primary-500/30 mb-6">
          <i className="ri-fire-fill text-primary-400 text-sm"></i>
          <span className="text-sm text-primary-300 font-medium">新用户注册即享专属福利礼包</span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-background-50 mb-4 leading-tight">
          {siteConfig.tagline}
        </h1>
        <p className="text-base md:text-lg text-background-50/70 max-w-2xl mx-auto mb-8 leading-relaxed">
          {siteConfig.description.slice(0, 100)}...
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/qipai"
            className="px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-medium text-base whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-all hover:scale-105"
          >
            <i className="ri-gamepad-line mr-2"></i>
            进入游戏大厅
          </Link>
          <button className="px-8 py-3.5 rounded-full bg-background-50/10 backdrop-blur-sm border border-background-50/30 text-background-50 font-medium text-base whitespace-nowrap cursor-pointer hover:bg-background-50/20 transition-all">
            <i className="ri-user-add-line mr-2"></i>
            立即注册
          </button>
        </div>

        <div className="grid grid-cols-3 gap-6 md:gap-12 mt-14 max-w-2xl mx-auto">
          {[
            { value: '5000万+', label: '注册用户' },
            { value: '1000+', label: '精品游戏' },
            { value: '24h', label: '在线客服' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl md:text-3xl font-heading text-primary-400 mb-1">{stat.value}</div>
              <div className="text-xs md:text-sm text-background-50/60">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}